export default __webpack_public_path__ + "static/media/korede.c753b38d.png";